import React from 'react';
import { Chip } from 'features/pi/view/uiManager/suggestion-chips/chip/chip';
import styles from './suggestion-chips.module.scss';

export const SuggestionsChipsInfo: { [key: string]: string }[] = [
    {
        title: 'How Do I',
        icon: 'GraduationCap',
    },
    {
        title: 'Where is',
        icon: 'ArrowArcRight',
    },
    {
        title: 'Placer Terms',
        icon: 'Books',
    },
    {
        title: 'Success Stories',
        icon: 'Strategy',
    },
    {
        title: 'Placer Updates',
        icon: 'CirclesThreePlus',
    },
];
type SuggestionChipsProps = {
    onClick: (text: string) => void;
};

export const SuggestionChips = ({ onClick }: SuggestionChipsProps) => {
    return (
        <div className={styles.container}>
            {SuggestionsChipsInfo.map(({ title, icon }) => {
                return <Chip key={title} text={title} onClick={onClick} iconType={icon} />;
            })}
        </div>
    );
};
